import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { SubPage } from "@/components/sub-page";
import { supabase } from "@/integrations/supabase/client";

export const Route = createFileRoute("/comunicaciones/recursos")({
  head: () => ({
    meta: [
      { title: "Documentos y Recursos | Mine Class" },
      { name: "description", content: "Radiografías, memorias y otros recursos documentales de Mine Class." },
      { property: "og:title", content: "Documentos y Recursos | Mine Class" },
      { property: "og:description", content: "Descarga radiografías del sector, memorias anuales y recursos documentales de Mine Class." },
      { property: "og:url", content: "https://mine-class.com/comunicaciones/recursos" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mine-class.com/comunicaciones/recursos" }],
  }),
  component: Page,
});

type Doc = { id: string; title: string; area: string | null; description: string | null; file_url: string; file_name: string | null };

function Page() {
  const [items, setItems] = useState<Doc[]>([]);
  useEffect(() => {
    (async () => {
      const { data } = await supabase
        .from("documentos" as never)
        .select("id,title,area,description,file_url,file_name")
        .eq("is_published", true)
        .order("created_at", { ascending: false });
      setItems((data ?? []) as Doc[]);
    })();
  }, []);

  return (
    <SubPage
      section="comunicaciones"
      eyebrow="Comunicaciones"
      title="Documentos"
      intro="Radiografías de la Capacitación Minera, memorias y otros recursos descargables."
    >
      {items.length === 0 ? (
        <p className="text-[var(--color-on-surface-variant)]">Aún no hay documentos publicados.</p>
      ) : (
        <div className="bg-white border border-[var(--color-outline-variant)] not-prose">
          <table className="w-full text-sm">
            <thead className="bg-[var(--color-surface-container-low)] text-left">
              <tr>
                <th className="px-4 py-3">Título</th>
                <th className="px-4 py-3">Área</th>
                <th className="px-4 py-3">Archivo</th>
              </tr>
            </thead>
            <tbody>
              {items.map((d) => (
                <tr key={d.id} className="border-t border-[var(--color-outline-variant)]">
                  <td className="px-4 py-3">
                    <div className="font-bold text-[var(--color-brand-purple)]">{d.title}</div>
                    {d.description && <div className="text-xs text-[var(--color-on-surface-variant)] mt-1">{d.description}</div>}
                  </td>
                  <td className="px-4 py-3">
                    {d.area ? (
                      <span className="inline-block bg-[var(--color-surface-container-low)] px-2 py-1 text-xs">{d.area}</span>
                    ) : (
                      <span className="text-xs text-[var(--color-on-surface-variant)]">—</span>
                    )}
                  </td>
                  <td className="px-4 py-3">
                    <a
                      href={d.file_url}
                      download={d.file_name ?? true}
                      target="_blank"
                      rel="noreferrer"
                      className="inline-flex items-center gap-1 bg-[var(--color-brand-coral)] text-white px-3 py-1.5 text-xs font-bold uppercase tracking-wider hover:brightness-110"
                    >
                      ↓ Descargar
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </SubPage>
  );
}
